<template>
<div class="margin-top-2">
  <div class="visits-table-header">
    <div class="custom-page-link">
      <p>Page link:</p>
      <a :href="page_link" target="_blank">{{page_link}}</a>
    </div>
    <div class="export-block">
      <button @click="$emit('export-visits')" class="btn export-btn">
          <span class="export-btn-icon">
            <img src="../../assets/export.svg" alt="">
          </span>
        <span class="export-btn-text">Export users</span>
      </button>
    </div>
  </div>
  <div class="visits-table">
    <table>
      <tr v-if="visits.length === 0" class="empty-tr">
        <td>
          <span>No data</span>
        </td>
      </tr>
      <tr v-if="visits.length > 0">
        <th class="user_id">
          <span>Id</span>
        </th>
        <th class="status">
          <span>Status</span>
        </th>
        <th class="date">
          <span>Date</span>
        </th>
        <th class="fb" v-if="available_networks.includes('facebook')">
          <span>Facebook</span>
        </th>
        <th class="instagram" v-if="available_networks.includes('instagram')">
          <span>Instagram</span>
        </th>
        <th class="twitter" v-if="available_networks.includes('twitter')">
          <span>Twitter</span>
        </th>
        <th class="linkedin" v-if="available_networks.includes('linkedin')">
          <span>LinkedIn</span>
        </th>
        <th class="twitter" v-if="available_networks.includes('tiktok')">
          <span>TikTok</span>
        </th>
        <th class="youtube" v-if="available_networks.includes('youtube')">
          <span>YouTube</span>
        </th>
        <th class="youtube" v-if="available_networks.includes('telegram_channel')">
          <span>Telegram users</span>
        </th>
        <th v-if="available_networks.includes('email')">
          <span>Emails</span>
        </th>
        <th v-if="available_networks.includes('sms')">
          <span>Mobile numbers</span>
        </th>
        <th v-if="available_networks.includes('telegram')">
          <span>Telegram accounts</span>
        </th>
      </tr>
      <tr v-for="(visit, index) in visits" :key="index">
        <td class="user_id">
          <span>{{visit.id}}</span>
        </td>
        <td class="status">
          <span class="status-success" v-if="visit.result">success</span>
          <span class="status-failure" v-if="!visit.result">failure</span>
        </td>
        <td>
          <span>{{visit.created_at | moment("MM-DD-YYYY") }}</span>
        </td>
        <td :class="countColumnWidth()" v-if="available_networks.includes('facebook')">
          <span v-if="visit.networks.length > 0 && visit.networks.find(v => v.type.toLowerCase() === 'facebook')">
            {{visit.networks.find(v => v.type.toLowerCase() === 'facebook').user}}
          </span>
          <span v-else> - </span>
        </td>
        <td :class="countColumnWidth()"
            v-if="available_networks.includes('instagram')">
          <span v-if="visit.networks.length > 0 && visit.networks.find(v => v.type.toLowerCase() === 'instagram')">
            {{visit.networks.find(v => v.type.toLowerCase() === 'instagram').user}}
          </span>
          <span v-else> - </span>
        </td>
        <td :class="countColumnWidth()" v-if="available_networks.includes('twitter')">
          <span v-if="visit.networks.length > 0 && visit.networks.find(v => v.type.toLowerCase() === 'twitter')">
            {{visit.networks.find(v => v.type.toLowerCase() === 'twitter').user}}
          </span>
          <span v-else> - </span>
        </td>
        <td :class="countColumnWidth()" v-if="available_networks.includes('linkedin')">
          <span v-if="visit.networks.length > 0 && visit.networks.find(v => v.type.toLowerCase() === 'linkedin')">
            {{visit.networks.find(v => v.type.toLowerCase() === 'linkedin' && !!v.user).user}}
          </span>
          <span v-else> - </span>
        </td>
        <td :class="countColumnWidth()" v-if="available_networks.includes('tiktok')">
          <span v-if="visit.networks.length > 0 && visit.networks.find(v => v.type.toLowerCase() === 'tiktok')">
            {{visit.networks.find(v => v.type.toLowerCase() === 'tiktok').user}}
          </span>
          <span v-else> - </span>
        </td>
        <td :class="countColumnWidth()" v-if="available_networks.includes('youtube')">
          <span v-if="visit.networks.length > 0 && visit.networks.find(v => v.type.toLowerCase() === 'youtube')">
            {{visit.networks.find(v => v.type.toLowerCase() === 'youtube').user}}
          </span>
          <span v-else> - </span>
        </td>
        <td :class="countColumnWidth()" v-if="available_networks.includes('telegram_channel')">
          <a :href="'https://t.me/' + visit.networks.find(v => v.type.toLowerCase() === 'telegram_channel').user"
             v-if="visit.networks.length > 0 && visit.networks.find(v => v.type.toLowerCase() === 'telegram_channel')">
            {{'@' + visit.networks.find(v => v.type.toLowerCase() === 'telegram_channel').user}}
          </a>
          <span v-else> - </span>
        </td>
        <td :class="countColumnWidth()" v-if="available_networks.includes('email')">
          <span v-if="visit.networks.length > 0 && visit.networks.find(v => v.type.toLowerCase() === 'email')">
            {{visit.networks.find(v => v.type.toLowerCase() === 'email').user}}
          </span>
          <span v-else> - </span>
        </td>
        <td v-if="available_networks.includes('sms')">
          <span v-if="visit.networks.length > 0 && visit.networks.find(v => v.type.toLowerCase() === 'sms')">
            {{visit.networks.find(v => v.type.toLowerCase() === 'sms').user}}
          </span>
          <span v-else> - </span>
        </td>
        <td v-if="available_networks.includes('telegram')">
          <span v-if="visit.networks.length > 0 && visit.networks.find(v => v.type.toLowerCase() === 'telegram')">
            {{visit.networks.find(v => v.type.toLowerCase() === 'telegram').user}}
          </span>
          <span v-else> - </span>
        </td>
      </tr>
    </table>
    <pagination
        @change-page="$emit('change-page', $event)"
        :current-page="current_page"
        :total-pages="total_pages"
    />
  </div>
</div>
</template>
<script>
import pagination from "@/components/__new_ui_kit/Pagination/Pagination";
export default {
  data () {
    return {
      test: 'test'
    }
  },
  components: {
    pagination
  },
  props: {
    available_networks: {
      type: Array,
      default: () => {
        return [
          'facebook',
          'instagram',
          'twitter',
          'linkedin',
          'tiktok',
          'youtube',
          'email',
          'sms',
          'telegram'
        ]
      }
    },
    page_link: {
      type: String
    },
    visits: {
      type: Array
    },
    current_page: {
      type: Number,
      default: () => {
        return 1
      }
    },
    total_pages: {
      type: Number,
      default: () => {
        return 3
      }
    }
  },
  methods: {
    countColumnWidth () {
      return this.available_networks.length > 0 ? 'width-' + this.available_networks.length : ''
    }
  }
}
</script>
<style lang="sass" scoped>
.visits-table-header
  display: flex
  flex-wrap: nowrap
  justify-content: space-between
  background: #f8f8f8
  padding: 13px 15px
  .custom-page-link
    display: flex
    flex-wrap: nowrap
    align-items: center
    justify-content: flex-start
    max-width: calc(100% - 122px)
    overflow: hidden
    p
      font-family: 'Montserrat', sans-serif
      font-size: 20px
      font-weight: 500
      line-height: 24px
      white-space: nowrap
    a
      margin: 3px 0 0 10px
      font-size: 14px
      font-weight: 500
      color: #279AEA
      max-width: calc(100% - 100px)
      text-overflow: ellipsis
      overflow: hidden
      white-space: nowrap
  .export-block
    .btn
      max-width: 122px
.visits-table
  overflow-x: auto
  margin-bottom: 40px
  .__custom-pagination
    margin-top: 10px
    margin-bottom: 10px
    margin-left: 2px
  table
    width: 100%
    .empty-tr
      text-align: center
      width: 100%
      span
        font-weight: 500
    tr
      height: 68px
      border-bottom: 1px solid #E2E2E2
      th
        min-width: 100px
        padding: 0 12px
        span
          font-size: 14px
          font-weight: 600
          white-space: nowrap
          color: #717171
      td.width-2
        width: 700px
        max-width: 700px
        min-width: 700px
      td.width-3
        width: 500px
        max-width: 500px
        min-width: 500px
      td.width-4
        width: 400px
        max-width: 400px
        min-width: 400px
      td.width-5
        width: 400px
        max-width: 400px
        min-width: 400px
      td.width-6
        width: 300px
        max-width: 300px
        min-width: 300px
      td.width-7
        width: 240px
        max-width: 240px
        min-width: 240px
      td.width-8
        width: 220px
        max-width: 220px
        min-width: 220px
      @media (max-width: 1920px)
        td.width-2
          width: 500px
          max-width: 500px
          min-width: 500px
        td.width-3
          width: 340px
          max-width: 340px
          min-width: 340px
        td.width-4
          width: 260px
          max-width: 260px
          min-width: 260px
        td.width-5
          width: 230px
          max-width: 230px
          min-width: 230px
        td.width-6
          width: 190px
          max-width: 190px
          min-width: 190px
        td.width-7
          width: 170px
          max-width: 170px
          min-width: 170px
        td.width-8
          width: 190px
          max-width: 190px
          min-width: 190px
      @media (max-width: 1441px)
        td.width-2
          width: 340px
          max-width: 340px
          min-width: 340px
        td.width-3
          width: 260px
          max-width: 260px
          min-width: 260px
        td.width-4
          width: 210px
          max-width: 210px
          min-width: 210px
        td.width-5
          width: 180px
          max-width: 180px
          min-width: 180px
        td.width-6
          width: 170px
          max-width: 170px
          min-width: 170px
        td.width-7
          width: 120px
          max-width: 160px
          min-width: 160px
        td.width-8
          width: 160px
          max-width: 160px
          min-width: 160px
      @media (max-width: 1025px)
        td.width-2
          width: 210px
          max-width: 210px
          min-width: 210px
        td.width-3
          width: 210px
          max-width: 210px
          min-width: 210px

      td.user_id
        width: 60px
        min-width: 60px
      td.status
        .status-success
          color: #00A65A
          font-weight: 600
        .status-failure
          color: #f491ab
          font-weight: 600
      th.user_id
        width: 60px
        min-width: 60px
      td
        padding: 0 12px
        min-width: 100px
        max-width: 260px
        overflow: hidden
        span
          white-space: nowrap
          text-overflow: ellipsis
          overflow: hidden
          display: block
          width: 100%
          font-size: 14px
          font-weight: 400
          color: #333333
    tr:nth-child(2n)
      background: #F8F8F8
@media (max-width: 690px)
  .visits-table-header
    flex-wrap: wrap
    .custom-page-link
      max-width: 100%
      p
        font-size: 18px
      a
        margin: 2px 0 0 10px
    .export-block
      margin-top: 14px
      width: 100%
      max-width: 100%
      .btn
        max-width: 100%
        width: 100%

</style>